interface ChevronDownIconProps {
  className?: string;
}

const ChevronDownIcon = ({ className = '' }: ChevronDownIconProps) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 9l6 6 6-6'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default ChevronDownIcon;
